import React from 'react';

/**
 * Read-only details shown as label / value pairs in a grid (a student's or staff member's profile).
 * Empty values show a dash so the layout stays even.
 */
export const InfoItem = ({ label, value, className = '' }) => {
  const isEmpty = value === null || value === undefined || value === '' || value === 'N/A' || value === 'Not Specified';

  return (
    <div className={`min-w-0 ${className}`}>
      <dt className="text-xs font-medium text-ui-ink-3">{label}</dt>
      <dd className={`mt-1 text-sm break-words ${isEmpty ? 'text-ui-ink-3' : 'text-ui-ink'}`}>
        {isEmpty ? '—' : value}
      </dd>
    </div>
  );
};

/**
 * Grid of InfoItems. `columns` is 1, 2, 3 or 4.
 */
const InfoGrid = ({ columns = 3, className = '', children }) => {
  const columnClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
  };

  return (
    <dl className={`grid gap-x-6 gap-y-4 ${columnClasses[columns] || columnClasses[3]} ${className}`}>
      {children}
    </dl>
  );
};

export default InfoGrid;
